import { render } from "./useLegends.vue?vue&type=template&id=4862be0c&scoped=true"
import script from "./useLegends.vue?vue&type=script&lang=js"
export * from "./useLegends.vue?vue&type=script&lang=js"

import "./useLegends.vue?vue&type=style&index=0&id=4862be0c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4862be0c"]])

export default __exports__